import { Toast } from '@zep-us/zus/toast';
import { ICON_COLOR } from '@zep-us/zus/tokens';
import { CheckSmallCircleFillIcon } from '@/icons';
import { cn } from '@/utils/tailwind.util';
export const AVATAR_SAVED_TOAST_COPY = {
  title: {
    key: 'common:avatarDecorate.saveSuccessToast'
  }
} as const;

/**
 * 아바타 저장 완료 토스트.
 *
 * 저장을 누르면 꾸미기 모달이 닫히는 것으로 끝나서, 정말 저장됐는지 알 길이 없었다.
 * 모달이 사라진 자리에 이 한 줄이 대신 답한다.
 *
 * 왼쪽 초록 체크는 시안(1945:5093)이 정한 「됐다」의 표시다. 구매 토스트
 * (`PurchaseToast`)의 젤리 아이콘과 역할이 다르다 — 그쪽은 무엇을 샀는지를 말하고,
 * 이쪽은 저장이 끝났음만 말한다. 그래서 반짝임·회전 같은 축하 연출은 얹지 않는다.
 */
export function AvatarSavedToast({
  message,
  /** react-hot-toast 의 `t.visible`. false 로 바뀌면 퇴장 연출을 태운다. */
  isVisible = true
}: {
  message: string;
  isVisible?: boolean;
}) {
  return <Toast title={message} leftSlot={<CheckSmallCircleFillIcon size="md" color={ICON_COLOR.positive} />} className={cn(isVisible ? 'animate-point-toast-in' : 'animate-point-toast-out', 'motion-reduce:animate-none')} data-sentry-element="Toast" data-sentry-component="AvatarSavedToast" data-sentry-source-file="AvatarSavedToast.tsx" />;
}